module.exports = __webpack_public_path__ + "media/images/map-marker-e20df72e47eec6804054d04589dcc832.svg";